/** @format */

export const CartSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.06699 12.4C4.26033 12.4 3.60766 13.06 3.60766 13.8667C3.60766 14.6734 4.26033 15.3334 5.06699 15.3334C5.87366 15.3334 6.53366 14.6734 6.53366 13.8667C6.53366 13.06 5.87366 12.4 5.06699 12.4ZM0.666992 0.666687V2.13335H2.13366L4.77366 7.69935L3.78366 9.49602C3.66633 9.70135 3.60033 9.94335 3.60033 10.2C3.60033 11.0067 4.26033 11.6667 5.06699 11.6667H13.867V10.2H5.37499C5.27233 10.2 5.19166 10.1194 5.19166 10.0167L5.21366 9.92869L5.87366 8.73335H11.337C11.887 8.73335 12.371 8.43269 12.6203 7.97802L15.2457 3.21869C15.3043 3.11602 15.3337 2.99135 15.3337 2.86669C15.3337 2.46335 15.0037 2.13335 14.6003 2.13335H3.75433L3.06499 0.666687H0.666992ZM12.4003 12.4C11.5937 12.4 10.941 13.06 10.941 13.8667C10.941 14.6734 11.5937 15.3334 12.4003 15.3334C13.207 15.3334 13.867 14.6734 13.867 13.8667C13.867 13.06 13.207 12.4 12.4003 12.4Z"
                fill={color}
            />
        </svg>
    );
};
